export const data = {
    experience:[
        {
            title: "BARISTA/CUSTOMER SERVICE",
            subTitle: "BRANDON, MB",
            startend: "SEPTEMBER 2019 - MAY 2022",
            describtion: "Provided the necessary drinks and took orders from customers"
        },
        {
            title: "FLAGPERSON",
            subTitle: "BRANDON, MB",
            startend: "JULY 2021 - AUGUST 2021",
            describtion: "Controlled the safety of traffic and road construction"
        }
    ],
    education: [
        {
            title: "HIGH SCHOOL GRADUATE",
            subTitle: "VINCENT MASSEY HIGH SCHOOL",
            startend: "SEPTEMBER 2014 - JUNE 2018",
            describtion: "Senior coursework included: AP-Biology, Chemistry, Pre-Calculus, AP-Physics"
        },
        {
            title: "ROBERTSON COLLEGE GRADUATE",
            subTitle: "ROBERTSON COLLEGE",
            startend: "SEPTEMBER 2021 - JUNE 2022",
            describtion: "Finishing up Full-Stack Web Developer courses"
        }
    ]
}